import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { HeadphonesIcon, MicIcon, VolumeIcon } from "../Icons";
import { DeviceDropdown } from "../DeviceDropdown/DeviceDropdown";
import { MicMeter } from "../MicMeter/MicMeter";
import { TestSpeakers } from "../TestSpeakers/TestSpeakers";
import { DeviceRow, MicColumn, SpeakerColumn } from "../styles";
import okoCharacter from "assets/OKO_op2_yellow.svg";
import okoCharacterNoMouth from "assets/OKO_op2_yellow2.svg";
import okoAniMouth from "assets/OKO_AniMouth_HigherRez.gif";
import okoCharacterShadow from "assets/Shadow.svg";

export const DeviceCheckUI = ({
  audioInputDevices,
  audioOutputDevices,
  localAudioTrack,
  mediaStreamTrack,
  localAudioInputDeviceId,
  activeAudioSinkId,
  setActiveAudioSinkId,
  replaceAudioInputTrack,
  isSpeakerPlaying,
  handleSpeakerPlayingChange,
  onSoundDetected,
}) => (
  <>
    {/* Row 1: OKO Bot + Headphones guidance */}
    <BotRow>
      <OkoCharacterWrapper>
        <OkoCharacterShadow src={okoCharacterShadow} alt="" />
        <OkoCharacterImg src={isSpeakerPlaying ? okoCharacterNoMouth : okoCharacter} alt="OKO" />
        <OkoMouth $visible={isSpeakerPlaying} />
      </OkoCharacterWrapper>
      <GuidanceBubble>
        <HeadphonesIcon />
        <GuidanceText>
          Use headphones and make sure they're plugged all the way in.
        </GuidanceText>
      </GuidanceBubble>
    </BotRow>

    {/* Row 2: Device dropdowns */}
    <DeviceRow>
      <MicColumn>
        <DeviceDropdown
          icon={<MicIcon />}
          devices={audioInputDevices}
          selectedDeviceId={localAudioInputDeviceId}
          onSelect={replaceAudioInputTrack}
          fallbackLabel={localAudioTrack?.mediaStreamTrack?.label || "No microphone found"}
        />
        <MicMeter mediaStreamTrack={mediaStreamTrack} onSoundDetected={onSoundDetected} />
      </MicColumn>
      <SpeakerColumn>
        <DeviceDropdown
          icon={<VolumeIcon />}
          devices={audioOutputDevices}
          selectedDeviceId={activeAudioSinkId}
          onSelect={setActiveAudioSinkId}
          fallbackLabel="System Default"
        />
        <TestSpeakers activeAudioSinkId={activeAudioSinkId} onPlayingChange={handleSpeakerPlayingChange} />
      </SpeakerColumn>
    </DeviceRow>
  </>
);

const BotRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 536px;
`;

const OkoCharacterWrapper = styled.div`
  position: relative;
  width: 210px;
  flex-shrink: 0;

  @media (max-width: 1024px), (max-height: 700px) {
    width: 147px;
  }
`;

const OkoCharacterImg = styled.img`
  width: 210px;
  position: relative;
  z-index: 2;

  @media (max-width: 1024px), (max-height: 700px) {
    width: 147px;
  }
`;

const OkoCharacterShadow = styled.img`
  width: 210px;
  position: absolute;
  bottom: -10px;
  left: 0;
  z-index: 1;

  @media (max-width: 1024px), (max-height: 700px) {
    width: 147px;
  }
`;

const OkoMouth = styled.div`
  background-image: url(${({ $visible }) => ($visible ? okoAniMouth : "none")});
  background-size: cover;
  border-radius: 50%;
  width: 52%;
  aspect-ratio: 1;
  position: absolute;
  left: 28%;
  top: 30%;
  z-index: 10;
`;

const GuidanceBubble = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background: ${colors.blue100};
  border-radius: 24px 24px 24px 0;
  position: relative;
  flex: 1;

  &::before {
    content: '';
    position: absolute;
    bottom: -12px;
    left: -10px;
    width: 0;
    height: 0;
    border-top: 12px solid ${colors.blue100};
    border-right: 12px solid ${colors.blue100};
    border-bottom: 12px solid transparent;
    border-left: 12px solid transparent;
    transform: rotate(-45deg);
  }

  svg {
    flex-shrink: 0;
  }
`;

const GuidanceText = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: ${colors.nightlyWoods500};
  margin: 0;
`;

